/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

export const addSavedSearch = createAsyncThunk(
  'savedSearches/add',
  async (
    {
      name, data, shared, showToast = true,
    },
    {
      extra: {
        sdk, Logger, Toast, localization: l18n, showErrorDialog, utils,
      },
    },
  ) => {
    try {
      const { data: newItem } = await sdk.savedSearches.create(name, data, shared);
      if (showToast) {
        Toast(l18n.TAGSTREE.alertSearchAdded(name), { type: 'success' });
      }
      newItem.nodes = [];

      return { newItem };
    } catch (error) {
      const errorStatus = utils.getStatusFromResponceError(error);
      if (errorStatus === 403) {
        showErrorDialog(l18n.NO_PERMISSION_TO_ACCESS);
      } else {
        Logger.error(new Error('Can not add saved searches'), { error }, [
          'AddSavedSearchesFailed',
          { errorMessage: (error && error.message) || 'NoMessage' },
        ]);
      }

      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    addSavedSearch.pending,
    (state) => {
      state.isAdding = true;
    },
  ).addCase(
    addSavedSearch.fulfilled,
    (state, { payload: { newItem } }) => {
      state.isAdding = false;
      if (newItem.teamId) {
        state.tree.teamSearches.nodes.push(newItem);
      } else {
        state.tree.personalSearches.nodes.push(newItem);
      }
      state.all.push(newItem);
    },
  ).addCase(
    addSavedSearch.rejected,
    (state, { error }) => {
      state.isAdding = false;
      state.error = error;
    },
  );
};
